<script>
    export default {
        data: () => ({
            error: false,
            timeout: null
        }),
        errorCaptured(err, vm, info) {
            // let vmName = get(vm, '$options.name', '')
            this.error = true
            // this.errorMessage = `${err.message} on '${info}' inside '${vmName}' component`
            // this.errorInfo = info
            // this.errorVm = vm
            // console.warn(err, vm, info)
        },
        render(h) {
            if (this.timeout) {
                clearTimeout(this.timeout)
            }
            // let children = [
            //     h('div', { attrs: { class: 'text-main-xl text-center font-semibold' } }, this.$t('widget.content.renderError')),
            //     h('div', { attrs: { class: 'text-main-sm text-center' } }, this.errorMessage),
            // ]
            if (this.error) {
                this.timeout = setTimeout(() => {
                    this.error = false
                }, 500);
            }
            return this.error ? h('div') : this.$slots.default[0]
        }
    }
</script>
<style>
</style>
